export * from "ce/plugins/Linting/utils/isLintErrorLoggingEnabledForEntity";
import isLintErrorLoggingEnabledForEntity from "ce/plugins/Linting/utils/isLintErrorLoggingEnabledForEntity";

export default isLintErrorLoggingEnabledForEntity;
